import React, { useEffect, useState, useRef } from 'react';
import { connect } from "react-redux";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import { Redirect, Link } from "react-router-dom";
import Spinner from '../common/spinner';
import InHomeConfirmationModal from './InHomeConfirmationModal';
import { Modal, Radio } from "../ecosystem/";
import { InHomeMainPanel, InHomeOverviewPanel, InHomePatientNameHeading, InHomeSplitLayout } from "./layout"


const InHomeCovidSurvey = ({
    history,
    selectedVaccines,
    engageHelpDeskNumber,
    getEligibilityQPending,
    success,
    getCovidQuestionnaires,
    sendQuestionnaires,
    getCovidQuestionnaireQResult,
    getCovidQuestionnaireQResultData,
    saveCovidServiceResults,
    resetCovidData,
    setSelectedVaccines,
    hasSomeSelectedVaccines }) => {
    
    const [covidQuestionsData, setCovidQuestionsData] = useState(null);
    const [nextCovidQuestionUrl, setNextCovidQuestionUrl] = useState(null);
    const [prevCovidQuestionUrl, setPrevCovidQuestionUrl] = useState(null);
    const [usersWithCovidVax, setUsersWithCovidVax] = useState(null);
    const [currentUserIndex, setCurrentUserIndex] = useState(0);
    const [selectedOptionIndex, setSelectedOptionIndex] = useState(null);
    const [isLastPatient, setIsLastPatient] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [userMessage, setUserMessage] = useState(null);
    const questionnaireResponse = useRef([]);
    const covidServiceResults = useRef([]);


    useEffect(() => {

        logUI(`MBHWeb.UI.InHomeCovidSurvey.Displayed`, new Date(), Tools.getURLPath());
        //console.log("MBHWeb.UI.InHomeCovidSurvey.Displayed");
        resetCovidData(); //Initially, initialize the covid questionnaire, and service results data
        let usersWithCovid = selectedVaccines.filter((user) => user.vaccines_groups.find(group => group.vaccines.find(vaccines => vaccines.name.toLowerCase().includes('covid') && vaccines.isChecked)));
        setUsersWithCovidVax(usersWithCovid);
       

        //console.log("Users with covid vax ", usersWithCovid);
        //console.log("CurrentUserIndex in the beginning ", currentUserIndex);

        let covGroup = usersWithCovid[currentUserIndex]?.vaccines_groups?.find(grp => grp?.group?.toLowerCase().includes('covid'));
        let covVaccine = covGroup?.vaccines?.find(vac => vac?.name?.toLowerCase().includes('covid'));
        let covidQURL = covVaccine?.questionnaire;
        //console.log("CovidUrl for start is ", covidQURL);
        if (covidQURL) getCovidQuestionnaires(covidQURL);

        return function cleanUp()  {
            resetCovidData(true);  //reset only covid questionnaire data
        }

    }, [])


    /*useEffect(() => {
        logUI(`MBHWeb.UI.InHomeCovidSurvey.Displayed`, new Date(), Tools.getURLPath());       
    }, [getCovidQuestionnaires]);*/

    const translateAlertMessage = (alertMessage) => {
        let translatedMessage = {title: '', body: alertMessage};
        switch (alertMessage.toLowerCase()) {
            case 'series mix alert':
                translatedMessage.title = `We don't currently offer ${usersWithCovidVax?.[currentUserIndex]?.first_name}'s Vaccine Series at home.`;
                translatedMessage.body = "The CDC does not recommend mixing vaccines for your primary series. Follow up with your doctor to get a vaccine in your series."
                break;
            case 'follow up with pcp alert':
                //let msg = `${usersWithCovidVax[currentUserIndex].first_name} is not eligible for the (Moderna) In-Home Vaccine. Contact ${usersWithCovidVax[currentUserIndex].first_name}'s doctor for additional vaccine options`;
                translatedMessage.title = `${usersWithCovidVax?.[currentUserIndex]?.first_name} is not eligible for the (Moderna) In-Home Vaccine.`;
                translatedMessage.body = `Contact ${usersWithCovidVax?.[currentUserIndex]?.first_name}'s doctor for additional vaccine options.`;

            default:
                return translatedMessage;
        }

        return translatedMessage;
    }

    const removeCovidVaccineForUser = (mrn, vaccineName) => {

        let currentSelectedVaccines = [...selectedVaccines];
        //find user
        let selectedUser = currentSelectedVaccines.find((user) => user.mrn === mrn && user.vaccines_groups.find(grp => grp.group === 'covid' && grp.vaccines.find(vaccines => vaccines.isChecked)))
        //update vaccine checked status

        let selectedGroup = selectedUser?.vaccines_groups?.find(grp => grp.group === 'covid');
        if (selectedGroup) {
            selectedGroup.isChecked = false;
            selectedGroup.vaccines.forEach(vax => vax.isChecked = false);
        }
        //console.log('Selected vaccines after removing covid vax for user with MRN is ', mrn, currentSelectedVaccines);
        setSelectedVaccines(currentSelectedVaccines);
    }


    useEffect(() => {

        if (!getCovidQuestionnaireQResult) return;

        if (!getEligibilityQPending && !getCovidQuestionnaireQResult.success) {  
            setShowModal(true);
        }

        if (!getEligibilityQPending && getCovidQuestionnaireQResultData) {

            //console.log("Received valid QResult. Setting state to this value ", getCovidQuestionnaireQResultData);          


           
                setCovidQuestionsData(getCovidQuestionnaireQResultData);


                //if we have exhausted all questions for current user, then increment the currentuserindex
                if (getCovidQuestionnaireQResultData?.question === null) {
                    //console.log("QResult has changed.  currentUserIndex is ", currentUserIndex);
                    //console.log("Now, incrementing and setting currentuserindex");
                    setCurrentUserIndex(currentUserIndex + 1);
                    //console.log("New currentUserIndex is ", currentUserIndex);

                    updateCovidServiceResults();  //save the covid screening results, locally
                    let userMessage = getCovidQuestionnaireQResultData?.result?.user_message;
                    if (userMessage && !userMessage.toLowerCase().includes('scheduling flow'))  //api has provided some message to show to the user
                    {
                        let alertMessageObj = translateAlertMessage(getCovidQuestionnaireQResultData?.result?.user_message);
                        setUserMessage(alertMessageObj);
                        //setUserMessage(getCovidQuestionnaireQResultData?.result?.user_message);
                        //console.log("About to remove covid vaccines for user with MRN ", getCovidQuestionnaireQResultData?.mrn);
                        removeCovidVaccineForUser(getCovidQuestionnaireQResultData?.mrn, 'covid');
                        setShowModal(true);

                    }


                }
            
        }



    }, [getCovidQuestionnaireQResult, getCovidQuestionnaireQResultData]);



    const updateCovidServiceResults = () => {
        const {mrn, questionnaire_id, result} = getCovidQuestionnaireQResultData;

        const { success, axle_service_name, epic_visit_id } = getCovidQuestionnaireQResultData?.result;
        //console.log("Covid Questionnaire Result for user  --> ", getCovidQuestionnaireQResultData);

        if (success) {
            covidServiceResults.current.push({ mrn, questionnaire_id, axle_service_name, epic_visit_id });
            //console.log("Updated covidservice results are ", covidServiceResults.current);
            saveCovidServiceResults(covidServiceResults.current);

        }

    }

    const onPrevious = () => {
        //need to return user to the overall vaccine eligibility screen
        let eligibilityRoute = { pathname: '/inhomeschedule/s5', state: { fromCovidSurvey: true } };
        history.push(eligibilityRoute);

        /*
        if (prevCovidQuestionUrl != null) //we need to get the previous covid question from api
            getCovidQuestionnaires(prevCovidQuestionUrl);
        else {
            //need to return user to the overall vaccine eligibility screen
            let eligibilityRoute = { pathname: '/inhomeschedule/s5', state: { fromCovidSurvey: true } };
            history.push(eligibilityRoute);
        }*/
    }



    useEffect(() => {

        //check for the next patient
        if (usersWithCovidVax) {
            //console.log("CurrentUserIndex, usersWithCovixVax ", currentUserIndex, usersWithCovidVax);
            if (currentUserIndex + 1 > usersWithCovidVax.length) {
                setIsLastPatient(true);
                if (!showModal)
                    history.push("/inhomeschedule/s6");
                return;
            }

        //if there are other patients that need to get their questionnaire, get them
            if (currentUserIndex + 1 <= usersWithCovidVax.length) {

                let covGroup = usersWithCovidVax[currentUserIndex]?.vaccines_groups?.find(grp => grp?.group?.toLowerCase().includes('covid'));
                let covVaccine = covGroup?.vaccines?.find(vac => vac?.name?.toLowerCase().includes('covid'));
                let covidQURL = covVaccine?.questionnaire;
                //console.log("CovidUrl for start and currentUserIndex is ", covidQURL, currentUserIndex);
                if (covidQURL) getCovidQuestionnaires(covidQURL);

            }

        }
    }, [currentUserIndex])


    const onClickNext = () => {

        const hasMoreQuestionsForPatient = covidQuestionsData?.question != null || covidQuestionsData?.result == null;

        if (!hasMoreQuestionsForPatient) {
            setCurrentUserIndex(currentUserIndex + 1);
            //go to scheduling page, if we have shown survey questions for all users
            history.push("/inhomeschedule/s6")
        }
        else {
            //fetch next question for user
            getCovidQuestionnaires(nextCovidQuestionUrl);
        }

        setNextCovidQuestionUrl(null);
        setPrevCovidQuestionUrl(null);
        setSelectedOptionIndex(null);
    }

    const onCheckChanged = (e, option, optionIndex) => {

        if (e.target.checked) {
            //console.log("selectedOptionIndex, nexturl, prevurl, ", optionIndex, option.next, option.prev);
            setNextCovidQuestionUrl(option.next);
            setPrevCovidQuestionUrl(option.prev);
            setSelectedOptionIndex(optionIndex);
        }
        else {
            setNextCovidQuestionUrl(null);
            setPrevCovidQuestionUrl(null);
            setSelectedOptionIndex(null);
        }

    }

    const onClickPrevious = () => {
        onPrevious();
    }

    const closeModal = () => {
        setUserMessage(null);
        setShowModal(false);
        //If this modal was displayed due to anAPI error (400/500 etc..), thenredirect theu ser to the dashboard
        if (!getEligibilityQPending && (!getCovidQuestionnaireQResult?.success || getCovidQuestionnaireQResult?.errorMsg))
            history.push("/");
        else
        //console.log("In closeModal, currentUserIndex is ", currentUserIndex)
        if ((currentUserIndex + 1) > usersWithCovidVax.length || isLastPatient) {
            //let hasSomeSelectedVaccines = selectedVaccines?.some(user => user?.vaccines_groups?.find(grp => grp?.vaccines?.some(vax => vax.isChecked === true)));
            if (hasSomeSelectedVaccines)
                history.push("/inhomeschedule/s6")
            else
                history.replace("/inhomeschedule/s4");
        }
       
    }

    const getBlockedNextLocation = () => {
        if (currentUserIndex && usersWithCovidVax && ((currentUserIndex + 1) > usersWithCovidVax?.length || isLastPatient)) {
            if (hasSomeSelectedVaccines)
                return "/inhomeschedule/s6";
            else
                return "/inhomeschedule/s4";
        } else {
            if (!getCovidQuestionnaireQResult?.success || getCovidQuestionnaireQResult?.errorMsg) {
                return "/inhomeschedule/s4";
            } else {
                return "";
            }
        }
    }

    const cancelBooking = () => {
        setShowModal(false);
        history.push("/")
    }

    const navigateToHome = () => {
        setShowModal(false);
        history.push("/");
    }

    return (
        <>
            {(usersWithCovidVax && !usersWithCovidVax?.length > 0) || selectedVaccines?.length < 1
                ? <Redirect to='/inhomeschedule/s5' />
                : <>
                    <InHomeSplitLayout
                        className="inhome-scheduling-covid-survey-container"
                        progressPercent={5 / 7 * 100}
                    >
                        {/*!getEligibilityQPending && !success && <SectionLoadingError message="Failed to load. Please try again" />*/}
                        {!getEligibilityQPending && covidQuestionsData && covidQuestionsData?.question 
                            ? <InHomeMainPanel
                                heading={covidQuestionsData?.question?.text}
                                subheading={
                                    covidQuestionsData?.question?.notes.map((note, i) => {
                                        return <div key={`note-${i}`}>NOTE: {note}</div>
                                    })
                                }
                                schedulingButtons={{
                                    disabledNext: !nextCovidQuestionUrl,
                                    leftOnClick: onClickPrevious,
                                    rightOnClick: onClickNext
                                }}
                            >

                                <div className="row">
                                    <div className="col-12 col-lg-10 eligibility-detail-wrapper">
                                        <InHomePatientNameHeading
                                            patientName={`${usersWithCovidVax?.[currentUserIndex]?.first_name} ${usersWithCovidVax?.[currentUserIndex]?.last_name} (${usersWithCovidVax?.[currentUserIndex]?.dob})`}
                                        />
                                        <div className="vaccine-question-wrapper" >
                                            <div className="vaccine-question-wrapper__group select-group-wrapper">
                                                {
                                                    covidQuestionsData?.question?.options.map((option, i) => {
                                                        let checkedOption = typeof selectedOptionIndex === "number" ? selectedOptionIndex === i : false;
                                                        return (
                                                            <div className="vaccine-question-wrapper__item" key={`option-${i}`}>
                                                                <Radio
                                                                    name={'Covid-Qstns'}
                                                                    onChange={(e) => onCheckChanged(e, option, i)}
                                                                    label={<span dangerouslySetInnerHTML={{ __html: option.text }} />}
                                                                    checked={checkedOption}
                                                                    size="md"
                                                                    variant="select"
                                                                />
                                                            </div>
                                                        )
                                                        
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </InHomeMainPanel>
                            : <InHomeMainPanel
                                schedulingButtons={{
                                    disabledNext: !nextCovidQuestionUrl,
                                    leftOnClick: onClickPrevious,
                                    rightOnClick: onClickNext
                                }}
                            >
                                {getEligibilityQPending &&
                                    <Spinner />
                                }
                            </InHomeMainPanel>
                        }

                        <InHomeConfirmationModal blockedNextLocation={getBlockedNextLocation()} />

                        <Modal
                            isOpen={showModal}
                            //className="appt-booking-modal"
                            //onCloseClick={() => { closeModal() }}
                            modalHeader={
                                !getEligibilityQPending && (!getCovidQuestionnaireQResult?.success || getCovidQuestionnaireQResult?.errorMsg) 
                                    ? "Oops, something went wrong."
                                    : userMessage && userMessage.title
                            }
                            modalBody={
                                !getEligibilityQPending && (!getCovidQuestionnaireQResult?.success || getCovidQuestionnaireQResult?.errorMsg) 
                                    ? <span>{<span>Call <a className="bsw-phone-link" href={"tel:" + engageHelpDeskNumber}>{engageHelpDeskNumber}</a> to schedule or try again later.</span> || getCovidQuestionnaireQResult?.errorMsg}</span>
                                    : userMessage && userMessage.body
                            }
                            modalFooterButtons={(!getCovidQuestionnaireQResult?.success || getCovidQuestionnaireQResult?.errorMsg)
                                ? [{ label: "Back to dashboard", onClick: navigateToHome }]
                                : (usersWithCovidVax && usersWithCovidVax.length > 1) || hasSomeSelectedVaccines
                                    ? [{ label: "Continue booking", onClick: closeModal },
                                    { label: "Cancel booking", onClick: cancelBooking }]
                                    : [{ label: "Back to dashboard", onClick: navigateToHome }]
                            }
                        />

                        <InHomeOverviewPanel eligibilityPhase={true} />
                    </InHomeSplitLayout>

                </>
            }
        </>
    );
}
const mapStateToProps = state => {

    return {
        selectedVaccines: state.inHome.selectedVaccines,
        getEligibilityQPending: state.inHome.getEligibilityQPending,
        getCovidQuestionnaireQResultData: state.inHome.getCovidQuestionnaireQResult?.data || null,
        getCovidQuestionnaireQResult: state.inHome.getCovidQuestionnaireQResult || null,        
        success: state.inHome.getCovidQuestionnaireQResult?.success || null,
        hasSomeSelectedVaccines: state.inHome.selectedVaccines?.some(user => user?.vaccines_groups?.find(grp => grp?.vaccines?.some(vax => vax.isChecked === true))),
        engageHelpDeskNumber: state.session.serverData?.engageHelpDeskNumber || '833.466.3020'
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getCovidQuestionnaires: (covidQuestionnaireUrl) => {
            dispatch({ type: types.GET_INHOME_ELIGIBILITY_COVID_Q,  covidQuestionnaireUrl  })
        },
        sendQuestionnaires: (response) => {
            dispatch({ type: types.SEND_INHOME_ELIGIBILITY_RESPONSES, response })
        },
        saveCovidServiceResults: (covidServiceResults) => {
            dispatch({ type: types.SAVE_COVID_SERVICE_RESULTS, covidServiceResults })
        },
        setSelectedVaccines: (data) => {
            dispatch({ type: types.SET_INHOME_VACCINES, data })
        },
        resetCovidData: (resetOnlyCovidQData = false) => {
            dispatch({ type: types.RESET_COVID_DATA, resetOnlyCovidQData })
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InHomeCovidSurvey);